// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__tCVQY","box":"styles_box__H3722","icon":"styles_icon__vkQcJ"};